exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tabs[data-v-19886c3c] {\n  overflow-x: auto;\n  overflow-y: hidden;\n  /* flex-wrap: wrap; */\n  /* flex-wrap: nowrap; */\n  width: 90%;\n  padding-left: 0px;\n  display: flex;\n  align-items: center;\n  list-style: none;\n  border-bottom: 2px solid #ebf1fa;\n}\n", ""]);

// exports
